import React from "react";

const ArrowSVG = () => {
    return (
        <svg width="35" height="24" viewBox="0 0 37 26" className="arrow" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 13L34 13" stroke="#FFF5B0" strokeWidth="2"/>
            <path d="M23.9878 1L35.0001 13L23.9878 25" stroke="#FFF5B0" strokeWidth="2"/>
        </svg>
    );
};

export default ArrowSVG;
